import React, { useContext, useEffect } from 'react';
import {
  AuDirectionLink,
  AuFormItemWrapper
} from 'components/DTA';
import { FormContext, OrganisationContext } from 'contexts';
import { getPortalUrl } from 'components/Portal/Utilities';
import { useSelector } from 'react-redux';
import { urlSelector } from 'PortalStore/Selectors/EnvDataSelectors';
import { useFormikContext } from 'formik';
import { DampReportApplicationFormData } from 'types/forms/dampReportApplicationTypes';

interface IFinalStepProps {
  organisationId: string;
};
const FinalStep: React.FC<IFinalStepProps> = ({ organisationId }) => {
  const { organisationDetailsResponse } = useContext(OrganisationContext);
  const B2CSettings = useSelector((state: any) => state.B2CSettings);
  const urlHome = useSelector((state: any) => urlSelector(state, 'Portal - Home URL'));
  const { formAlert } = useContext(FormContext);
  const { resetForm } = useFormikContext<DampReportApplicationFormData>();

  useEffect(() => {
    resetForm(); // reset formik form so exit modal is not triggered
  }, []);

  const handleBackToDashBoard = () => {
    const jparams = { 'from': 'org', 'organisationId': organisationId };
    const dashboardUrl = getPortalUrl('/dashorg', B2CSettings.items.standalone, urlHome) + '&params=' + encodeURIComponent(btoa(JSON.stringify(jparams))) + '&casaorgid=' + organisationId;
    window.location.href = dashboardUrl;
  };

  return (
    <>
      {
        formAlert &&
        formAlert[0] &&
        formAlert[0].as === 'success' &&
        <div style={{ marginTop: '30px' }}>
          <AuFormItemWrapper>
            <p>
            CASA will assess your report shortly and may contact you if required to discuss your submission. Confirmation of your submission has been sent to
            your organisation&apos;s email <strong>{organisationDetailsResponse?.value?.value[0]?.emailaddress1}</strong>.
            </p>
            <p>You should receive this email shortly.</p>
          </AuFormItemWrapper>
          <br />
        </div>
      }
      <AuFormItemWrapper>
        <AuDirectionLink onClick={handleBackToDashBoard} text="Return to myCASA" direction="left" />
      </AuFormItemWrapper>
    </>
  );
};

export default FinalStep;